import React from 'react';
import moment from 'moment';
import 'moment/locale/fr';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import { IngenieOtOuvertures, OtTemplateQuery } from '../../../../graphql-types';
import * as styles from './openings.module.scss';

interface IOpeningsProps {
  openings: NonNullable<OtTemplateQuery['ingenieOt']>['ouvertures'];
}

type Opening = {
  dates: [string, string];
  days: string[];
  hours: [string, string][];
};

type ArrOpening = Opening[];

const getOpenings = (openings: NonNullable<OtTemplateQuery['ingenieOt']>['ouvertures']) => {
  const today = moment().format();
  const filteredOpenings = openings?.filter((x) =>
    moment(today).isSameOrAfter(moment(x?.date_debut).subtract(6, 'months'))
  );
  const initArray: ArrOpening = [];
  const ouvertures: ArrOpening =
    filteredOpenings?.reduce((res, x) => {
      const alreadyMorning = res.find(
        (e) =>
          e?.dates[0] === x?.date_debut &&
          e?.dates[1] === x?.date_fin &&
          e?.days?.every((d, index) => x?.jours_semaine?.[index] === d) &&
          e?.hours?.[0]?.[0] !== x?.heure_debut &&
          e?.hours?.[0]?.[1] !== x?.heure_fin
      );
      if (alreadyMorning) {
        alreadyMorning.hours.push([x?.heure_debut ?? '', x?.heure_fin ?? '']);
        return res;
      }
      const days: string[] =
        x?.jours_semaine?.reduce<string[]>((ret, d) => {
          if (d !== null && d !== undefined) ret.push(d);
          return ret;
        }, []) ?? [];
      res.push({
        dates: [x?.date_debut ?? '', x?.date_fin ?? ''],
        days,
        hours: x?.heure_debut ? [[x?.heure_debut ?? '', x?.heure_fin ?? '']] : [],
      });
      return res;
    }, initArray) ?? [];
  return ouvertures;
};

const mergeOneDayEvents = (openings: NonNullable<OtTemplateQuery['ingenieOt']>['ouvertures']) => {
  if (openings?.some((o) => o?.date_debut !== o?.date_fin)) {
    return null;
  }

  const dictByDate =
    openings?.reduce((ret, op) => {
      const key = `${op?.date_debut ?? ''}${op?.date_fin ? `-${op?.date_fin}` : ''}`;
      return { ...ret, [key]: [...(ret?.[key] ?? []), op] };
    }, {}) ?? {};

  const buildComp = Object.values(dictByDate).map((pair) => {
    const oneDayComp = isOneDayEvent(pair);
    return oneDayComp;
  });
  return buildComp;
};

const renderOpening = (opening?: IngenieOtOuvertures | null) => {
  if (!opening || !opening.date_debut || !opening.heure_debut || !opening.heure_fin) return null;
  return (
    <div className={styles.oneDayWrapper}>
      <p className={styles.oneDay}>
        {moment(opening.date_debut, 'YYYY-MM-DD').format('dddd DD MMMM YYYY')}
      </p>
      <div className={styles.hours}>{`${opening.heure_debut} - ${opening.heure_fin}`}</div>
    </div>
  );
};

const isOneDayEvent = (openings: NonNullable<OtTemplateQuery['ingenieOt']>['ouvertures']) => {
  // if (openings?.length !== 2) return [false, null];

  // const eventDay = openings[0]?.date_debut;
  // if (!openings.every((o) => o?.date_debut === o?.date_fin && o?.date_fin === eventDay)) {
  //   return null;
  // }
  const oneDayEventComponent = <>{openings?.map((opening) => renderOpening(opening))}</>;
  return oneDayEventComponent;
};

export const Openings = ({ openings }: IOpeningsProps) => {
  const { lang } = usePageContext();
  const today = moment().format();
  const currentOpenings = openings?.filter((x) => moment(today).isSameOrBefore(x?.date_fin)) ?? [];
  const oneDayComp = mergeOneDayEvents(currentOpenings);
  const computedOpenings = getOpenings(currentOpenings);
  moment.locale(lang);
  const formatDate = (date) => moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
  return (
    <ul className={styles.listWrapper}>
      {oneDayComp ??
        computedOpenings?.map((x) => (
          <li className={styles.wrapper} key={`opening-${JSON.stringify(Object.values(x))}`}>
            <div className={styles.dates}>
              <div>{formatDate(x.dates[0])}</div>
              <div>-</div>
              <div>{formatDate(x.dates[1])}</div>
            </div>
            {x.hours.length > 0 && (
              <div className={styles.hours}>
                {x.hours.map((h) => (
                  <div
                    key={`hours-${JSON.stringify(Object.values(x))}`}
                    className={styles.hours}
                  >{`${h[0]} - ${h[1]}`}</div>
                ))}
              </div>
            )}
            <div className={styles.days}>
              {(x.days.length === 0 ? [1, 2, 3, 4, 5, 6, 7] : x.days)
                .map((d) => moment.weekdays(+d))
                .join(', ')}
            </div>
          </li>
        ))}
    </ul>
  );
};
